import { render } from "./OrdersManagerSettingsStage.vue?vue&type=template&id=5953b5e4&scoped=true"
import script from "./OrdersManagerSettingsStage.vue?vue&type=script&lang=js"
export * from "./OrdersManagerSettingsStage.vue?vue&type=script&lang=js"

import "./OrdersManagerSettingsStage.vue?vue&type=style&index=0&id=5953b5e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5953b5e4"]])

export default __exports__